import { loaderService } from "../../../common/custom-loader/loader-service";
import { STAKEHOLDER_MAPPING_VALIDATION, CONFIG_MASTER_CONTROLLER, GET_ALL_MAPPED_STAKEHOLDER, GET_All_STATE, GET_All_DISTRICT, authKey, GET_PROBABLE_LIST_FOR_STAKEHOLDER_MAPPING, LIST_OF_PROBABLE_MAPPINGS, SAVE_RESOURCE_STAKEHOLDER_MAPPING, EDIT_RESOURCE_STAKEHOLDER_MAPPING, CRITERIA_BASED_GET_STAKEHOLDER, SAVE_MULTIPLE_RESOURCE_STAKEHOLDER_MAPPING, CHECK_MAPPING_EXISTS } from '../../../common/URLs';

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from 'react-toastify';
import apiClient from "../../../axios";

export function getStakeholderType(setchooseUser) {
    loaderService.showLoader();
    apiClient
      .post(CONFIG_MASTER_CONTROLLER + `?serviceType=Stakeholder_Mapping`,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setchooseUser(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

export function getAllState(setchooseState) {
    loaderService.showLoader();
    apiClient
      .post(GET_All_STATE,
        {

        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        setchooseState(response.data.stateList);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();

      });
  }

  export function getAllDistrict(setchooseDistrict,resourceState) {
    loaderService.showLoader();
    apiClient
      .post(GET_All_DISTRICT,
        {
          "state": resourceState
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        setchooseDistrict(response.data.districtLists);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }



export function gettoStakeholderType(setchooseFromUser,selectedfromstakeholder) {
    loaderService.showLoader();
    apiClient
      .post(GET_PROBABLE_LIST_FOR_STAKEHOLDER_MAPPING + `?appKey=${selectedfromstakeholder}`,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setchooseFromUser(response.data);
        loaderService.hideLoader();

      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();

      });
  }

  export function getSelectedStakeholderDetails(setSelectedStakeHolderDetails,growerLandId, growerUrn, choosetypestakeholder, lleUrn, growerType) {

    loaderService.showLoader();
    apiClient
      .post(LIST_OF_PROBABLE_MAPPINGS,
        {
          "growerLandId": growerLandId ? growerLandId : "",
          "growerUrn": growerUrn ? growerUrn : "",
          "type": choosetypestakeholder,
          "lleUrn": lleUrn?lleUrn : null,
          "growerType": growerType
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setSelectedStakeHolderDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  export function getAllStakeHolderDetails(setMappedToBeStakeholder,details) {
    loaderService.showLoader();
    apiClient
      .post(GET_ALL_MAPPED_STAKEHOLDER,
        {
          "district": details?.resourceDistrict,
          "state": details?.resourceState,
          "type": details?.RescChooseStakeholder,
          "toType": details?.RescChoosetoStakeholder
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setMappedToBeStakeholder(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }
/*
export  function saveStakeHolderMapping(mappeditem,details,updatedDetails,setSaveMappingData) {
    loaderService.showLoader();
    apiClient
      .post(SAVE_RESOURCE_STAKEHOLDER_MAPPING,
        {
          "sourceStakeholderType": details.RescChooseStakeholder,
          "transporterUrn": "",
          "sourceStakeholderUrn": mappeditem?.urn,
          "targetStakeholderType": details?.RescChoosetoStakeholder,
          "targetStakeholderUrn": updatedDetails?.UpdatedTargetUrn,
          "sourceGrowerLandId": mappeditem?.sourceGrowerLandId,
          "distance": updatedDetails?.inBetweenDistance
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setSaveMappingData(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }*/

export  function saveStakeHolderMapping(requestData,setSaveMappingData) {
    loaderService.showLoader();
    apiClient
      .post(SAVE_RESOURCE_STAKEHOLDER_MAPPING,
        {
          "requestData": requestData
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setSaveMappingData(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        // console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

 export function DeleteDeactiveEditTransporterMapping(updatedDetails,details,setSaveMappingData, data) {
  loaderService.showLoader();
    apiClient
      .post(EDIT_RESOURCE_STAKEHOLDER_MAPPING,
        {
          "route": "",
          "transporterUrn": "",
          "sourceStakeholderUrn": updatedDetails.growerUrn,
          "targetStakeholderUrn": updatedDetails.UpdatedTargetUrn,
          "id": updatedDetails.deactiveid ? updatedDetails.deactiveid : updatedDetails.deleteid,
          "delete": updatedDetails.deleteid ? "Y" : "N",
          "deactivate": updatedDetails.deactivestatus ? updatedDetails.deactivestatus : "N",
          "sourceStakeholderType": details.RescChooseStakeholder,
          "targetStakeholderType": details.RescChoosetoStakeholder,
          "sourceGrowerLandId": updatedDetails.sourceGrowerLandId
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setSaveMappingData(response.data);
     response?.data?.status === "SUCCESS" && checkMappingExists(data)
        loaderService.hideLoader();
        // console.log(response.data)
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  export function getMappedStakeholder(setchooseMappedStakeholder) {
    loaderService.showLoader();
    apiClient
      .post(CONFIG_MASTER_CONTROLLER + `?serviceType=Grower_HIT_Mapping`,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setchooseMappedStakeholder(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }


  export function getStakeholdersBasedOnCriteria(linkedTo,linkedToURN,Required,setGetHitDetails) {
    loaderService.showLoader();
    apiClient
      .post(CRITERIA_BASED_GET_STAKEHOLDER,
        {
          "required": Required,
          "linkedTo": [linkedTo],
          "urn": linkedToURN
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setGetHitDetails(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  export function getAllStakeholdersBasedOnCriteria(linkedTo,linkedToURN,Required,setGetAllDetails) {
    loaderService.showLoader();
    apiClient
      .post(CRITERIA_BASED_GET_STAKEHOLDER,
        {
          "required": Required,
          "linkedTo": [linkedTo],
          "urn": linkedToURN
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setGetAllDetails(response.data);
       loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }
  export function validation_check_mapping(requestData, setMappingValidationCheck, submit) {
    loaderService.showLoader();
   return apiClient
      .post(STAKEHOLDER_MAPPING_VALIDATION,
        {
          "requestData": requestData
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        loaderService.hideLoader();
        if(submit) {
          setMappingValidationCheck(response.data)
          !response.data?.every(item => item?.validationStatus?.status === "SUCCESS") && toast.error("Mappings Marked In Red Are Pending For Approval")
        }
        else {
          if(response.data[0]?.validationStatus?.status === "FAILURE") {
            return false
          }
          else  {
            return true
          }
        }
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }
  export function submitGrowerHitStakeHolderMapping(multipleMappingDetails, setMultipleSaveMappingData) {
    loaderService.showLoader();
    apiClient
      .post(SAVE_MULTIPLE_RESOURCE_STAKEHOLDER_MAPPING,
        {
          "requestData": multipleMappingDetails
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setMultipleSaveMappingData(response.data);
        // console.log(response.data)
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  export function checkMappingExists(data, openPopup, setMessage) {
    loaderService.showLoader();
    apiClient
      .post(CHECK_MAPPING_EXISTS,
        data,
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
      loaderService.hideLoader();
       setMessage(response.data)
       openPopup();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  export function DeleteDeactiveGrowerHitMapping(updatedDetails, setMultipleSaveMappingData, details, setGetAllDetails) {
    loaderService.showLoader();
    apiClient
      .post(EDIT_RESOURCE_STAKEHOLDER_MAPPING,
        {
          "route": "",
          "transporterUrn": "",
          "sourceStakeholderUrn": updatedDetails.growerUrn,
          "targetStakeholderUrn": updatedDetails.UpdatedTargetUrn,
          "id": updatedDetails.deactiveid ? updatedDetails.deactiveid : updatedDetails.deleteid,
          "delete": updatedDetails.deleteid ? "Y" : "N",
          "deactivate": updatedDetails.deactivestatus ? updatedDetails.deactivestatus : "N",
          "sourceStakeholderType": "Grower",
          "targetStakeholderType": "Hit"
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setMultipleSaveMappingData(response.data);
        getAllStakeholdersBasedOnCriteria(details.rescAlreadyMappedStakeholder, details.resMappedURN, 'Grower', setGetAllDetails)
        loaderService.hideLoader();
        // console.log(response.data)
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  export function viewMappedDetails(setLinkedtoArray, growerLandId, urn, setViewMappedStakeHolder) {
    loaderService.showLoader();
    apiClient
      .post(CRITERIA_BASED_GET_STAKEHOLDER,
        {
          "required":"Grower",
          "linkedTo":setLinkedtoArray,
          "urn":urn, 
          "growerLandId": growerLandId
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setViewMappedStakeHolder(response.data);
        // console.log(response.data)
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }